export const humanizedStatus = ( status : string) : string => {
  return statusToHuman[ status ];
};

const statusToHuman = {
  going: 'Going',
  interested: 'Interested',
  cannot_go: 'Not going',
}
